import mascotService from "../services/mascot.service";

const handlers = {
    mascot: {
        session: {
            set: "mascot_session_set"
        }
    }
}

const initVuexState = function(state) {
    state.mascot = {
        session: null
    };
}

const initGetters = function(getters) {
    getters.mascot = (state => state.mascot);
}

const initActions = function(actions) {
    actions[handlers.mascot.session.set] = ({ commit }, session) => commit(handlers.mascot.session.set, session);
}

const initMutations = function(mutations) {
    mutations[handlers.mascot.session.set] = (state, session) => state.mascot.session = session;
}

const initAppState = function(appState, store) {
    appState.mascot = {
        session: {
            get: () => store.getters.mascot.session,
            open: async options => {
                const session = await mascotService.openSession(options);
                store.dispatch(handlers.mascot.session.set, session);
            },
            openDemo: async options => {
                const session = await mascotService.openDemoSession(options);
                store.dispatch(handlers.mascot.session.set, session);
            },
            close: async () => {
                store.getters.mascot.session && await mascotService.closeSession();
                store.dispatch(handlers.mascot.session.set, null);
            }
        }
    }
}

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};


// WEBPACK FOOTER //
// ./_common/data/mascot.js